import {QueryGroupedEntry} from 'common/query-builder/query-entry-section/types';

import {BaseEntryRow} from '../base';
// eslint-disable-next-line import/no-cycle
import {GroupedEntryRowEl} from './template';

export class GroupedEntryRow extends BaseEntryRow<QueryGroupedEntry> {
  template = GroupedEntryRowEl;

  isPlaceholder() {
    return !this.entry.event.every((subEntry) => !!subEntry.event?.value);
  }

  isIntermediatePlaceholder() {
    return this.entry.event.some((subEntry) => !!subEntry.event?.value);
  }
}
